import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { Nullable } from '@ps/utils';
import { Supplier, SupplierAccessSave } from '../models/supplier.model';
import {
  SupplierBlend,
  SupplierBlendSave,
} from '../models/supplier-blend.model';
import {
  SupplierGroupTemplate,
  SupplierGroupTemplateSave,
} from '../models/supplier-group-template.model';

export const SupplierActions = createActionGroup({
  source: 'Supplier Access',
  events: {
    'Load Suppliers': props<{
      buyerId: number;
      countryId?: Nullable<number>;
      languageId?: Nullable<number>;
    }>(),
    'Load Suppliers Success': props<{ suppliers: Supplier[] }>(),
    'Load Suppliers Failure': props<{ error: string }>(),
    'Update Supplier': props<{ id: number; data: Partial<Supplier> }>(),
    'Save Supplier Access': props<SupplierAccessSave>(),
    'Save Supplier Access Success': emptyProps(),
    'Save Supplier Access Failure': props<{ error: string }>(),

    'Load Supplier Blends': emptyProps(),
    'Load Supplier Blends Success': props<{ blends: SupplierBlend[] }>(),
    'Load Supplier Blends Failure': props<{ error: string }>(),
    'Delete Supplier Blend': props<{ id: string }>(),
    'Delete Supplier Blend Success': props<{ id: string }>(),
    'Delete Supplier Blend Failure': props<{ error: string }>(),
    'Set Supplier Blend Default': props<{ id: string; isDefault: boolean }>(),
    'Set Supplier Blend Default Success': props<{
      id: string;
      isDefault: boolean;
    }>(),
    'Set Supplier Blend Default Failure': props<{ error: string }>(),
    'Lock All Supplier Blends': props<{ isLocked: boolean }>(),
    'Lock All Supplier Blends Success': props<{ isLocked: boolean }>(),
    'Lock All Supplier Blends Failure': props<{ error: string }>(),

    'Open Create Supplier Blend Form': emptyProps(),
    'Open Edit Supplier Blend Form': props<{ id: string }>(),
    'Close Supplier Blend Form': emptyProps(),

    'Create Supplier Blend': props<{ data: SupplierBlendSave }>(),
    'Create Supplier Blend Success': props<{ blend: SupplierBlend }>(),
    'Create Supplier Blend Failure': props<{ error: string }>(),

    'Update Supplier Blend': props<{
      id: string;
      data: SupplierBlendSave;
      keepFormOpen: boolean;
    }>(),
    'Update Supplier Blend Success': props<{
      blend: SupplierBlend;
      keepFormOpen: boolean;
    }>(),
    'Update Supplier Blend Failure': props<{ error: string }>(),

    'Load Group Templates': emptyProps(),
    'Load Group Templates Success': props<{
      templates: SupplierGroupTemplate[];
    }>(),
    'Load Group Templates Failure': props<{ error: string }>(),

    'Save Group As Template': props<{ data: SupplierGroupTemplateSave }>(),
    'Save Group As Template Success': emptyProps(),
    'Save Group As Template Failure': props<{ error: string }>(),
  },
});
